import styled from 'styled-components';
import { HistoryGraphContainer, HistoryGraphLoading } from '../styles';

export const CurrentHealthContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const HealthContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  flex-wrap: wrap;

  & > #upgrade-module-container {
    flex: 1 1 100%;
  }
`;

export const HealthHistoryCardLoading = styled(HistoryGraphLoading)`
  .skeleton-span {
    width: 712px;
  }
`;

export const HealthHistoryContainer = styled(HistoryGraphContainer)`
  gap: 20px;
  height: 372px;
  max-width: 712px;

  @media (max-width: 1024px) {
    height: 418px;
  }
`;

export const HealthGraphContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  width: 100%;
  flex: 1;
  gap: 8px;

  @media (max-width: 768px) {
    gap: 20px;
  }
`;
